/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export const EVENT_WEB_VITALS_CLS = 'WebVitalsCLSEvent';
export const EVENT_WEB_VITALS_FCP = 'WebVitalsFCPEvent';
export const EVENT_WEB_VITALS_FID = 'WebVitalsFIDEvent';
export const EVENT_WEB_VITALS_INP = 'WebVitalsINPEvent';
export const EVENT_WEB_VITALS_LCP = 'WebVitalsLCPEvent';
export const EVENT_WEB_VITALS_TTFB = 'WebVitalsTTFBEvent';

export interface IEventClientWebVitalsCLSMetrics {
    value: number;
}
